import { getRandomNegativeNumber } from '../Imaging/utils';
import { PlateTypeEnum } from './types';

export const defaultSaveContainerDropDTO = {
  id: getRandomNegativeNumber(),
  name: '',
  numRows: 0,
  numColumns: 0,
  defaultWellVolume: 0,
  defaultAdditiveVolume: 0,
  defaultDropVolume: 0,
  defaultSeedVolume: 0,
  defaultFragmentVolume: 0,
  maxWellVolume: 0,
  maxNumDrops: 1,
  maxDropVolume: 0,
  enable: true,
  inUse: false,
  isAtImager: false,
  containerDrops: [],
  type: PlateTypeEnum['Experiment Plate'],
};

export const plateTypeEditButtons = {
  Continue: 'Continue',
  Ok: 'Ok',
};

export const plateTypeEditHeading = 'Edit plate';

export const plateTypeInUseEditWarningMessage =
  'The plate is currently used in one or more experiments. Any changes you make will affect all experiments that use this plate.';

export const plateTypeInUseEditMessage =
  'Row and column values cannot be changed, and the maximum well volume, maximum drop volume and drop cannot be set lower than its original value.';

export const plateTypeInImagerEditMessage =
  'This Plate Type cannot be disabled because it is currently in the Image. Remove it from Imager and try again.';
